import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import { ThirdwebProvider } from "@thirdweb-dev/react";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThirdwebProvider
    activeChain="ethereum"
    clientId="234de47c39d9056361e1cb773cb42899b323cea8297ec984eb3232a4d8e5d414a5ea60db3c57aade8c06032165398fe8c9c1c567da7083c10eb2eb4cdeaecc87"
    sdkOptions={{
      gatewayUrls: ["https://truth.myfilebase.com/ipfs/"],
    }}
  >
    <App />
  </ThirdwebProvider>
);

reportWebVitals();
